import React, { Component } from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './result.css';
import { subscribeUserFavourites, setUserProfile, updateUserFavourites } from "../../../actions/userProfileActions";
import { connect } from "react-redux";

class Result extends Component {

    constructor(props) {
        super(props);
        this.state = {
            note: ''  // State to manage note input
        };
    }

    // Handle textarea changes
    handleChange = (event) => {
        this.setState({ [event.target.id]: event.target.value });
    };

    // Add favourite with note
    addFavourite = (event, code) => {
        event.preventDefault();

        const uid = this.props.userProfile.uid;
        const newItem = {
            code: code,
            note: this.state.note  // Take note from state
        };

        // Create a new array to avoid mutating props
        const favouriteList = [...(this.props.userProfile.favourites || []), newItem];

        // Call Redux action to update Firestore
        this.props.updateUserFavourites(uid, favouriteList);

        // Clear the textarea after adding
        this.setState({ note: '' });
    };

    render() {
        const props = this.props;
        const result = props.result;

        // Prepare note display if exists
        let noteDisplay = null;
        if (result.note) {
            noteDisplay = (
                <div className="result-item">
                    <div className="result-label">Navigational Note</div>
                    <div className="result-info">{result.note}</div>
                </div>
            );
        }

        // Prepare change display if exists
        let changeDisplay = null;
        if (result.change) {
            changeDisplay = (
                <div className="result-item">
                    <div className="result-label">Change</div>
                    <div className="result-info">{result.change}</div>
                </div>
            );
        }

        const uid = this.props.userProfile.uid;
        const favouriteList = this.props.userProfile.favourites || [];

        // Favourite view
        let favouriteView = null;
        if (uid) {
            // Check if this item already exists in favourites
            const existingFavourite = favouriteList.find(fav => fav.code === result.meddra_code);
            if (existingFavourite) {
                favouriteView = (
                    <div className="note-container">
                        <div className="note-label">My note</div>
                        <div className="note-info">{existingFavourite.note}</div>
                    </div>
                );
            } else {
                // Show form to add a new favourite
                favouriteView = (
                    <div>
                        <form onSubmit={(e) => this.addFavourite(e, result.meddra_code)}>
                            <FormGroup controlId="note">
                                <div>
                                    <FormControl
                                        componentClass="textarea"
                                        id="note"
                                        placeholder="Please note some information. You can see this note on the My favourites tab on Mobile apps and Web."
                                        value={this.state.note}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="submit-buttons">
                                    <button className="btn btn-success" type="submit">Add Note</button>
                                </div>
                            </FormGroup>
                        </form>
                    </div>
                );
            }
        } else {
            // Show login prompt if user is not logged in
            favouriteView = (
                <div>
                    <Link className="btn btn-success" to='/login'>Login</Link>
                    <div className="info-text">
                        You can add notes and favorites after Signup/Login. (Mobile apps and web sync all data in realtime)
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="favourite">{favouriteView}</div>
                <div className="list">
                    <div>
                        <div className="result">
                            <div className="result-item">
                                <div className="result-label">MedDRA Code</div>
                                <div className="result-info">{result.meddra_code}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">SOC</div>
                                <div className="result-info">{result.meddra_soc}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Term</div>
                                <div className="result-info">{result.ctcae_term}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Definition</div>
                                <div className="result-info">{result.definition}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 1</div>
                                <div className="result-info">{result.grade_1}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 2</div>
                                <div className="result-info">{result.grade_2}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 3</div>
                                <div className="result-info">{result.grade_3}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 4</div>
                                <div className="result-info">{result.grade_4}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 5</div>
                                <div className="result-info">{result.grade_5}</div>
                            </div>

                            {noteDisplay}
                            {changeDisplay}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userProfile: state.userProfile
});

export default connect(mapStateToProps, { setUserProfile, updateUserFavourites, subscribeUserFavourites })(Result);


// WEBPACK FOOTER //
// ./src/component/ctcae6/result/result.js